import { PURGE_DATA } from './timer';

const UPDATE_PAIRS = '@@checkout/bank/update_pairs';

const initialState = {
  bankName: '',
  bankCode: '',
  bankBranchName: '',
  bankBranchCode: '',
  bankAccountType: '',
  bankAccountNumber: '',
  bankAccountTitle: '',
};

const numberKeys = ['bankCode', 'bankBranchCode', 'bankAccountNumber'];

const stringKeys = [];

const form = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PAIRS: {
      const newState = Object.keys(action.pairs).reduce((accu, key) => {
        const _accu = { ...accu };

        _accu[key] = action.pairs[key];

        if (stringKeys.indexOf(key) > -1) {
          // includes `undefined` and `null`
          _accu[key] = _accu[key] || '';
        }

        if (numberKeys.indexOf(key) > -1) {
          // toString is to make sure unexpected input never cause issue
          _accu[key] = _accu[key].toString().replace(/\D/g, '');
        }

        return _accu;
      }, {});

      return {
        ...state,
        ...newState,
      };
    }
    case PURGE_DATA: {
      return initialState;
    }
    default:
      return state;
  }
};

export const updatePairs = pairs => ({
  type: UPDATE_PAIRS,
  pairs,
});

export default form;
